module.exports = __webpack_public_path__ + "static/img/bcg5.35fa1d1c.png";